import { createStyles, rem } from '@mantine/core'

import { DetectPageReturnType } from 'hooks/useDetectSCpage'
import { hexToRgb, hsbToRgb, rgbToHsb } from 'utils/colors'

interface StylesParams {
  primaryColor: string
  bodyColor?: string
  bodyBg?: string
  detectPage: DetectPageReturnType
}

export default createStyles((theme, params: StylesParams) => {
  const {
    primaryColor = theme.fn.primaryColor(),
    bodyColor,
    bodyBg,

    detectPage,
  } = params
  const { isCarePath, isDan, isSimilac } = detectPage

  const rgb: any = hexToRgb(primaryColor, true)
  const hsb = rgbToHsb(rgb.r, rgb.g, rgb.b)
  const btnColorRgb = hsbToRgb(hsb[0], hsb[1] + 24, hsb[2] - 4)
  const btnColor = isCarePath
    ? `rgb(${btnColorRgb[0]},${btnColorRgb[1]},${btnColorRgb[2]})`
    : primaryColor
  const btnColorHoverRgb = isCarePath
    ? hsbToRgb(hsb[0], hsb[1] + 40, hsb[2] - 4)
    : hsbToRgb(hsb[0], hsb[1] + 1, hsb[2] - 4)
  const btnColorHover = `rgb(${btnColorHoverRgb[0]},${btnColorHoverRgb[1]},${btnColorHoverRgb[2]})`
  return {
    root: {
      // position: 'relative',
      // zIndex: 304,
      ...(bodyColor && {
        backgroundColor: bodyColor,
      }),
      ...(bodyBg && {
        backgroundImage: `url(${bodyBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'top left',
      }),
      ...(primaryColor && {
        'button[data-variant="primary"],button[data-primary-btn="true"]': {
          '&:not(:disabled)': {
            ...(isDan && {
              color: '#001168',
              backgroundImage:
                'linear-gradient(90.02deg, #E3BE52 0.02%, #FCE7A3 29.55%, #EDC255 67.82%, #FADB7D 107.01%, #E5BA47 126.18%)',
            }),
            backgroundColor: btnColor,
            '&:hover': {
              backgroundColor: btnColorHover,
              ...(isDan && {
                color: '#001168',
                backgroundImage:
                  'linear-gradient(90.02deg, #E3BE52 0.02%, #FCE7A3 29.55%, #EDC255 67.82%, #FADB7D 107.01%, #E5BA47 126.18%)',
              }),
            },
          },
        },
      }),

      [theme.fn.smallerThan('sm')]: {
        '&.show-aside': {
          '.carepath-bottom-ad': {
            bottom: rem(64),
          },
        },
      },
      ...(isSimilac && {
        '[data-quo-si="true"] + [data-lead-si="true"]': {
          '.mantine-ServiceConnections__SectionWrapper-Wrapper-root': {
            paddingTop: 0,
            [theme.fn.largerThan('sm')]: {
              marginTop: -40,
            },
          },
        },
      }),
    },
  }
})
